import React, { useEffect, useState } from 'react';
import { ShoppingCart, CheckCircle2 } from 'lucide-react';
const NAMES = ['Carlos', 'Martín', 'Juan', 'Pablo', 'Sebastián', 'Nicolás', 'Fernando', 'Andrés', 'Matías', 'Gonzalo', 'Ramiro', 'Tomás', 'Emiliano', 'Santiago', 'Leandro'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Bahía Blanca', 'Resistencia', 'Posadas', 'Paraná'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setData({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimeout = setTimeout(showPopup, 4000);
    const interval = setInterval(() => {
      const randomDelay = Math.floor(Math.random() * 4000) + 8000;
      setTimeout(showPopup, randomDelay);
    }, 12000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-in slide-in-from-bottom-10 fade-in duration-500" data-id="element-182">
      <div className="bg-[#1a1a1a] rounded-lg shadow-xl border border-amber-800/40 p-4 flex items-center gap-4 max-w-sm" data-id="element-183">
        <div className="bg-amber-900/30 p-2 rounded-full flex-shrink-0" data-id="element-184">
          <ShoppingCart className="w-6 h-6 text-amber-500" data-id="element-185" />
        </div>
        <div data-id="element-186">
          <p className="text-sm font-medium text-white" data-id="element-187">
            <span className="font-bold" data-id="element-188">{data.name}</span> de{' '}
            <span className="font-bold" data-id="element-189">{data.city}</span>
          </p>
          <p className="text-xs text-gray-400 flex items-center mt-1" data-id="element-190">
            <CheckCircle2 className="w-3 h-3 mr-1 text-green-500" data-id="element-191" />
            Acaba de comprar el Mega Pack
          </p>
        </div>
      </div>
    </div>;
}